/**
 * Reads a pickup-location reference from Firestore, supporting the current
 * `*Id` fields and legacy embedded {@link PickupLocation} objects (uses `id` when present).
 */
export const parseStoredLocationId = (
  direct: unknown,
  legacy: unknown,
): string | undefined => {
  if (typeof direct === "string" && direct.trim()) {
    return direct.trim();
  }
  if (legacy && typeof legacy === "object" && !Array.isArray(legacy)) {
    const id = (legacy as { id?: unknown }).id;
    if (typeof id === "string" && id.trim()) {
      return id.trim();
    }
  }
  return undefined;
};

/** Normalizes an optional id for Firestore storage (`null` clears the field). */
export const locationIdForFirestore = (
  id: string | null | undefined,
): string | null => {
  const trimmed = id?.trim();
  return trimmed || null;
};
